import type { RouteObject } from 'react-router-dom';
import { paths } from '@/router/paths';
import { PassportPage } from './PassportPage';
import { PlaceholderPage } from '@/components/feedback/PlaceholderPage';

export const registryRoutes: RouteObject[] = [
  // Public — used by QR-scan landing.
  { path: paths.passport, element: <PassportPage /> },

  // Admin-side registry tooling lives under /registry; not built yet.
  {
    path: paths.registryAdmin,
    element: (
      <PlaceholderPage
        title="Registry"
        description="Admin tooling for publishability checks, exports, and audit logs is on the roadmap."
      />
    )
  }
];
